import { useFlags } from 'launchdarkly-react-client-sdk';
import { ClientProfileContentItem } from 'store/clientProfile/clientProfileSlice';

import NewNote from './newNote';
import OldNote from './note';

const Note = ({ note }: { note: ClientProfileContentItem }) => {
  const { enableBillingUpdates } = useFlags();

  return enableBillingUpdates ? <NewNote note={note} /> : <OldNote note={note} />;
};

export default Note;
